import { render, staticRenderFns } from "./ExpansionTable.vue?vue&type=template&id=a2737f54&scoped=true"
import script from "./ExpansionTable.vue?vue&type=script&lang=js"
export * from "./ExpansionTable.vue?vue&type=script&lang=js"
import style0 from "./ExpansionTable.vue?vue&type=style&index=0&id=a2737f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2737f54",
  null
  
)

export default component.exports